import { create } from 'zustand';

import { TrackingParams } from '@/api/types';

interface AuthState {
    token: string;
    setToken: (token: this['token']) => void;

    isAuth: boolean;
    setIsAuth: (isAuth: this['isAuth']) => void;

    msisdn: string;
    setMsisdn: (msisdn: this['msisdn']) => void;

    trackingParams: Partial<TrackingParams>;
    setTrackingParams: (trackingParams: this['trackingParams']) => void;

    clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(set => ({
    token: localStorage.getItem('token') ?? '',
    setToken: token => set(() => ({ token })),

    isAuth: false,
    setIsAuth: isAuth => set(() => ({ isAuth })),

    trackingParams: localStorage.getItem('trackingParams') ?? {
        utm_source: undefined,
        utm_medium: undefined,
        utm_campaign: undefined,
        utm_content: undefined,
        utm_term: undefined,
        invited_by: undefined,
        place_id: undefined,
        yclid: undefined,
        gclid: undefined,
    },
    setTrackingParams: trackingParams => set(() => ({ trackingParams })),

    msisdn: '',
    setMsisdn: msisdn => set(() => ({ msisdn })),

    clearAuth: () =>
        set(() => {
            localStorage.removeItem('token');

            return { msisdn: '', isAuth: false, token: '' };
        }),
}));
